"use strict";

function SyncStatusManager() {
  function init() {
    _setupSyncMonitoring();
    if (!Offline.onLine()) {
      updateStatus();
    }
  }

  function _setupSyncMonitoring() {
    $(window).on("offline", updateStatus);
    $(window).on("online", updateStatus);
    SyncManager.addStatusListener(updateStatus);
  }

  function resyncInspections() {
    ResourceController.sync();
  }

  function updateStatus() {
    const status = SyncManager.getStatus();
    const props = _getStatusProps(status);

    _addErrorInformation(props);

    StatusBanner.queueMessage({
      id: "sync-status",
      titleContracted: props.titleContracted,
      titleExpanded: props.titleExpanded,
      contentsHtml: _renderContentsHtml(props),
      priority: props.priority,
      displayStatus: props.displayStatus,
      buttonCallback: resyncInspections,
      dismissable: props.syncStatus === "done syncing",
    });
  }

  function _getStatusProps(status) {
    if (!ToolFunctions.getToolConfigProperty("offline", null, false) && !Offline.onLine()) {
      return {
        priority: 1,
        displayStatus: "warning",
        syncStatus: null,
        titleExpanded: "Offline is not supported in this tool",
        titleContracted: "Offline is not supported in this tool",
      };
    } else if (status.toSync === 0 && status.rejected > 0) {
      const props = {
        syncStatus: "error",
        priority: 5,
        displayStatus: "warning",
        titleExpanded:
          "Unable to sync, but don't panic, your data is saved to the browser cache. Please try resyncing later.",
        titleContracted: "Unable to sync",
      };

      return props;
    } else if (!Offline.onLine()) {
      return {
        priority: 3,
        displayStatus: "info",
        titleExpanded: "2N Offline",
        titleContracted: "Offline",
      };
    } else if (status.toSync > 0) {
      return {
        priority: 3,
        displayStatus: "success",
        syncStatus: "syncing",
        titleExpanded: "Data syncing to server...",
        titleContracted: "Data syncing to server...",
      };
    } else if (status.retry > 0) {
      return {
        priority: 1,
        displayStatus: "info",
        syncStatus: "retry",
        titleExpanded: "The sync timed out, it will automatically retry soon.",
        titleContracted: "Sync pending...",
        retryCount: status.retry,
      };
    } else {
      return {
        priority: 1,
        displayStatus: "success",
        syncStatus: "done syncing",
        titleExpanded: "2N Online",
        titleContracted: "Online",
      };
    }
  }

  function _addErrorInformation(props) {
    if (props.syncStatus === "error") {
      const lastUnresolvedSyncError = UserResource.getUserData("lastUnresolvedSyncError");
      if (lastUnresolvedSyncError) {
        props.syncError = lastUnresolvedSyncError;
      } else {
        props.syncError = _getSyncError();
        UserResource.setUserData("lastUnresolvedSyncError", props.syncError);
      }
    } else if (props.syncStatus === "done syncing") {
      UserResource.setUserData("lastUnresolvedSyncError", null);
    }
  }

  function _getSyncError() {
    const Sentry = require("@sentry/browser");
    const data = {
      t: DateTime.getNowIso(),
      i: Sentry.lastEventId(),
      b: global.twoNformBuildVersion.substring(0, 8),
    };
    return JSON.stringify(data).replace(/{|}|"/g, "");
  }

  function _renderContentsHtml(props) {
    let contentsHtml = "";

    if (props.displayStatus === "info" && !props.syncStatus) {
      contentsHtml += nunjucks.render("statusBanner/offline.njk", props);
    } else if (props.displayStatus === "success") {
      contentsHtml += nunjucks.render("statusBanner/online.njk", props);
    }

    if (props.syncStatus === "error") {
      contentsHtml += nunjucks.render("statusBanner/syncError.njk", props);
    } else if (props.syncStatus === "retry") {
      contentsHtml += nunjucks.render("statusBanner/syncRetry.njk", props);
    }

    contentsHtml += nunjucks.render("statusBanner/offlineFooter.njk", props);

    return contentsHtml;
  }

  return {
    init,
    updateStatus,
    resyncInspections,
  };
}

module.exports = SyncStatusManager();

const StatusBanner = require("../general/statusBanner");
const Offline = require("./offline");
const ResourceController = require("./resourceController");
const SyncManager = require("./syncManager");
const ToolFunctions = require("../toolFunctions");
const UserResource = require("./userResource");
const DateTime = require("../dateTime");
